import $ from 'jquery';

export default function () {

	$('.c-liftup ul li').click(function() {

		$('.c-liftup__content').removeClass('active');
		$(this).children('.c-liftup__content').addClass('active');
	});
}